import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
}

export function ModalSucessoReprovarLote({ show, handleClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Reprovar lote"
      centered={true}
      footer={false}
      footerConfirmButton={false}
    >
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        Lote reprovado com sucesso!
      </ModalBody>
    </ModalCustom>
  );
}
